import React from "react"
import { Link } from 'react-router-dom'
import CurrentLink from 'app/dodones/shared/CurrentLink'
import HeaderContext from 'app/HeaderContext'
import { useContext } from 'react'

export default ({ onNav }) => {
  const { MenuContent } = useContext(HeaderContext);

  return <div className="fcol flex-1 gap-2">
           <Link to={ "/dodones/today" } onClick={ onNav }> Today </Link>
           <CurrentLink onNav={ onNav } />
           { MenuContent ? <MenuContent onNav={ onNav } /> : null }
           <div className="flex-1" />
           <div className="text-sm text-gray-500"> { API_URL } </div>
         </div>
};
